import { render, staticRenderFns } from "./TransporterBidRateDetails.vue?vue&type=template&id=a2ba70aa&scoped=true"
import script from "./TransporterBidRateDetails.vue?vue&type=script&lang=js"
export * from "./TransporterBidRateDetails.vue?vue&type=script&lang=js"
import style0 from "./TransporterBidRateDetails.vue?vue&type=style&index=0&id=a2ba70aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ba70aa",
  null
  
)

export default component.exports